<template>
  <v-dialog
    v-model="dialog"
    width="1000px"
    scrollable
  >
    <template #activator="{ props }">
      <v-btn
        v-if="hasPermission('view ticket::settlement-reset')"
        color="primary"
        x-large
        block
        class="fraud-claim-dialog-btn mt-2"
        v-bind="props"
      >
        Reset Settlement
      </v-btn>
      <disabled-for-lack-of-role-btn
        v-else
        text="Reset Settlement"
        permission="view ticket::settlement-reset"
        :x-small="false"
        :x-large="true"
        :block="true"
        button-class="fraud-claim-dialog-btn mt-2"
      />
    </template>

    <v-card :loading="loadingModel">
      <v-card-title class="text-h5 grey lighten-2">
        Reset Settlement
      </v-card-title>

      <v-card-text class="py-5">
        In order to reset this Settlement, please click on the "Reset Settlement" button below.
        This action will do the following:
        <ul>
          <li>Delete the Settlement Portal Credit</li>
          <li>Delete any and all autopays</li>
          <li>
            Reverse any payments processed with apply date equal to or greater than
            tomorrow and void corresponding pending collections transaction in Secure
            Payments
          </li>
          <li>Place loan in previous Collections Status</li>
        </ul>
      </v-card-text>

      <v-divider />

      <v-card-actions class="py-3">
        <v-spacer />
        <v-btn
          v-if="hasPermission('create ticket::settlement-reset')"
          color="primary"
          :disabled="loadingModel"
          :loading="loadingModel"
          @click="resetSettlement()"
        >
          Reset Settlement
        </v-btn>
        <disabled-for-lack-of-role-btn
          v-else
          text="Reset Settlement"
          permission="create ticket::settlement-reset"
          :x-small="false"
        />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';

export default {
  name: 'ResetSettlementDialog',
  components: {
    DisabledForLackOfRoleBtn,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  emits: ['success'],
  data() {
    return {
      dialog: false,
      loadingModel: false,
      valid: true,
    };
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    async resetSettlement() {
      this.loadingModel = true;
      try {
        const res = await this.$axios
          .post('api/v1/support/ticket/settlement-reset/reset', {
            ticketId: this.ticket.crm.id * 1,
            loanId: this.ticket.active_loan.id * 1,
          });
        if (res.status === 200 && res.data) {
          let msg = 'You have successfully Reset the Settlement';
          if (res.data.message) {
            msg = res.data.message;
          }
          this.setNotification({
            message: msg,
            color: 'green',
          });
          this.loadingModel = false;
          this.dialog = false;
          this.$emit('success');
        }
      } catch (error) {
        let errMsg = 'There was an error processing your request';
        if (error.response && error.response.status === 404 && error.response.data) {
          errMsg = error.response.data.message;
        }
        this.loadingModel = false;
        this.setNotification({
          message: errMsg,
          color: 'red',
        });
      }
    },
  },
};
</script>
